import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import '../Fee/Pavatino1.css';
import AlertMessage from "../../AlertMessage";
import axios from 'axios';

function Pavatino1() {
    const location = useLocation();
    const [students, setStudents] = useState([]);
    const [studentDetails, setStudentDetails] = useState([]); // State to store student details
    const udiseNumber = localStorage.getItem("udiseNumber");
    const [filteredStudents, setFilteredStudents] = useState([]);
    const [isDataLoaded, setIsDataLoaded] = useState(false); // State to track data loading
    const [classWiseTotals, setClassWiseTotals] = useState({});
    const [feeData, setFeeData] = useState({});
    const navigate = useNavigate();
    const language = localStorage.getItem("language");
    const [selectAll, setSelectAll] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");
    const [showAlert, setShowAlert] = useState(false);
    const [sendingWhatsApp, setSendingWhatsApp] = useState(false);
    const [whatsAppSent, setWhatsAppSent] = useState(false);
    
      useEffect(() => {
        if (alertMessage) {
          setShowAlert(true);
          const timeoutId = setTimeout(() => {
            setShowAlert(false);
            setAlertMessage(""); 
          }, 3000);
          return () => clearTimeout(timeoutId);
        }
      }, [alertMessage]);
    // Ensure default values in case location.state is undefined
    const {
        year = '-',
        selectedClass = '-',
        division = '-', // Retrieve selectedDivision as divisionType
        schoolDetails = {},
        feeDetails: passedFeeDetails = {},
        selectedFee = '-', // Retrieve selectedFee
    } = location.state || {};

    // console.log("year---", year);
    // console.log("selectedClass", selectedClass);
    // console.log("selectedFee", selectedFee);
    // console.log("division", division);
    // console.log("passedFeeDetails", passedFeeDetails);

    const fetchData = async () => {
        const studentUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentData.json`;
        const feeUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/fees/${year}.json`;
        const studentFeeUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentFee/${year}.json`;

        try {
            const [studentResponse, feeResponse, studentFeeResponse] = await Promise.all([
                fetch(studentUrl),
                fetch(feeUrl),
                fetch(studentFeeUrl)
            ]);

            if (!studentResponse.ok || !feeResponse.ok || !studentFeeResponse.ok) {
                throw new Error('Failed to fetch data');
            }

            let studentData = await studentResponse.json();
            let feeData = await feeResponse.json();
            let studentFeeData = await studentFeeResponse.json();

            // Filter out null or undefined entries
            studentData = studentData ? Object.fromEntries(Object.entries(studentData).filter(([key, value]) => value !== null)) : {};
            feeData = feeData ? Object.fromEntries(Object.entries(feeData).filter(([key, value]) => value !== null)) : {};
            studentFeeData = studentFeeData ? Object.fromEntries(Object.entries(studentFeeData).filter(([key, value]) => value !== null)) : {};


            const filteredStudentData = Object.fromEntries(Object.entries(studentData).filter(([key]) => !studentFeeData[key]));

        // Filter active students
        const activeStudents = Object.fromEntries(
            Object.entries(studentData).filter(([key, student]) => 
                student.isActive === true || student.isActive === undefined
            )
        );

      

            let studentArray = [];
            if (selectedFee === "Fee Pending") {
                studentArray = Object.keys(activeStudents).map((key) => ({
                    registerNo: key,
                    ...activeStudents[key],
                }));
                // console.log("studentArray",studentArray);
                
            } else if (selectedFee === "Fee Completed" || selectedFee === "Fee Uncompleted") {
                studentArray = Object.keys(studentData).map((key) => ({
                    registerNo: key,
                    ...studentData[key],
                })).filter(student => student.isActive === true || student.isActive === undefined);
            }

            const studentMap = studentArray.reduce((acc, student) => {
                acc[student.serialNo] = student;
                return acc;
            }, {});

            const combinedData = studentArray.map((student) => {
                const fee = Object.values(feeData).find(f => f.feetype === student.feetype);
                return {
                    ...student,
                    amount: fee ? fee.amount : '',
                    feetype: fee ? fee.feetype : '',
                    schoolBus: fee ? fee.schoolBus : false,
                    currentClass: student.currentClass || '',
                };
            });

            setStudents(studentArray);
            setFilteredStudents(combinedData);
            setStudentDetails(studentMap);

            // Initialize classWiseTotals object
            const classWiseTotals = {};
            let allClassFees = 0; // Variable to track fees that apply to all classes

            // Process fee data
            Object.values(feeData).forEach(fee => {
                const classType = fee.classType;

                // Check if this fee applies to all classes
                if (classType === "All" && fee.amount) {
                    allClassFees += parseFloat(fee.amount); // Sum up all "All" class fees
                } else {
                    // For specific class types, initialize if not already done
                    if (!classWiseTotals[classType]) {
                        classWiseTotals[classType] = 0; // Initialize total for this classType
                    }
                    // Add fee amount to the corresponding classType total
                    if (fee.amount) {
                        classWiseTotals[classType] += parseFloat(fee.amount);
                    }
                }
            });

            // Now, add the allClassFees to each class type in classWiseTotals
            Object.keys(classWiseTotals).forEach(classType => {
                classWiseTotals[classType] += allClassFees; // Apply the "All" fees to each specific class
            });

            // Set the class-wise totals to state
            setClassWiseTotals(classWiseTotals);

            setIsDataLoaded(true); // Data loaded successfully

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        fetchData(); // Call fetchData when the component mounts
    }, []);

    useEffect(() => {
        fetchData(); // Fetch data on component mount or when UDISE number changes
    }, [udiseNumber]);

    // useEffect(() => {
    //     // console.log("Selected Fee Status:", selectedFee);
    // }, [selectedFee]);

    const processFee = (serialNo, feeKey, fee) => {
        const student = students.find(student => student.serialNo === parseInt(serialNo));
        // console.log("student", student);
                    // console.log("student",student);
        
        if (student) {
           const studentName = `${student.stdName || ''} ${student.stdFather || ''} ${student.stdSurname || ''}`.trim();

            const studentClass = student.currentClass || ' ';
            const rollNo = student.rollNo || ' ';
            const mobileNo = student.fMobile || student.mobileNo || ' ';
            // console.log("studentTotals[studentName]", student);
    
            // Initialize totals if not already present
            if (!studentTotals[studentName]) {
                studentTotals[studentName] = {
                    class: studentClass,
                    rollNo: rollNo,
                    totalAmount: 0,
                    totalDiscountAmount: 0,
                    totalBeforePay: 0,
                    totalRemainingAmount: 0,
                    totalRemainingFee: 0,
                    mobileNo:mobileNo,
                    paymentDate: '',
                };
            }
    
            // Accumulate totals for this student
            studentTotals[studentName].totalAmount += parseFloat(fee.amount || 0);
            studentTotals[studentName].totalDiscountAmount += parseFloat(fee.discountAmount || 0);
            studentTotals[studentName].totalBeforePay += parseFloat(fee.beforePay || 0);
            if (fee.date) {
                studentTotals[studentName].paymentDate = fee.date;
            }
    
            // Calculate the remaining fee based on your formula
            const calculatedRemainingAmount = studentTotals[studentName].totalAmount 
                                          - studentTotals[studentName].totalDiscountAmount 

            // Calculate the remaining fee based on your formula
            const calculatedRemainingFee = studentTotals[studentName].totalAmount 
                                          - studentTotals[studentName].totalDiscountAmount 
                                          - studentTotals[studentName].totalBeforePay;
                                        
            studentTotals[studentName].totalRemainingAmount = (calculatedRemainingAmount || 0);
    
            // Update the remaining fee in the totals
            studentTotals[studentName].totalRemainingFee = calculatedRemainingFee;
        }
    };
    

    const tableData = [];
    const studentTotals = {};

    // Loop through feeDetails and process the data
    Object.keys(passedFeeDetails).forEach((serialNo) => {
        const invoices = passedFeeDetails[serialNo];
        const lastInvoiceNo = Object.keys(invoices).pop();
        const studentFees = invoices[lastInvoiceNo];

        Object.keys(studentFees).forEach((feeKey) => {
            processFee(serialNo, feeKey, studentFees[feeKey]);
        });
    });

    Object.keys(studentTotals).forEach((studentName) => {
        const totals = studentTotals[studentName];
// console.log("studentTotals",studentTotals);
// console.log("studentName",studentName);

        let feeStatus = '';
        if (totals.totalRemainingFee > 0 && totals.totalRemainingFee < totals.totalRemainingAmount) {
            feeStatus = 'Fee Uncompleted'; 
        } else if (totals.totalRemainingFee === 0) {
            feeStatus = 'Fee Completed'; 
        } else {
            feeStatus = 'Fee Pending'; 
        }
// console.log("totals",totals);

        if (feeStatus === selectedFee) {
            tableData.push([
               
                totals.class,
                totals.rollNo,
                studentName,
                totals.totalAmount.toFixed(2),
                totals.totalDiscountAmount.toFixed(2),
                totals.totalRemainingAmount.toFixed(2),
                totals.totalBeforePay.toFixed(2),
                totals.paymentDate || '-',
                totals.totalRemainingFee.toFixed(2),
                totals.mobileNo,
            ]);
        }
    });
    const classTypeToTotal = {};
    Object.keys(classWiseTotals).forEach(classType => {
        classTypeToTotal[classType] = classWiseTotals[classType].toFixed(2);
    });
  
if (selectedFee === 'Fee Pending') {
    // Group students by class type and division
    const classWiseStudents = {};
    
    // Loop through all students to classify them by their current class and division
    students.forEach(student => {
        const studentClassType = student.currentClass || ' ';
        const studentDivision = student.division || ' '; // Assuming students have a `division` field
        
        if (!passedFeeDetails[student.serialNo]) {
            if (!classWiseStudents[studentClassType]) {
                classWiseStudents[studentClassType] = {};
            }

            if (!classWiseStudents[studentClassType][studentDivision]) {
                classWiseStudents[studentClassType][studentDivision] = [];
            }

            classWiseStudents[studentClassType][studentDivision].push(student);
        }
    });

    // Check if 'All' is selected in both class and division
    if (selectedClass === 'All' && division === 'All') {
        // Iterate over all classes and divisions in classWiseStudents
        Object.keys(classWiseStudents).forEach(classType => {
            Object.keys(classWiseStudents[classType]).forEach(studentDivision => {
                // console.log("classTypeToTotal",classTypeToTotal);
                
                const classTotalAmount = classTypeToTotal[classType] || '0.00';
                const remainingFee = classTotalAmount;
                classWiseStudents[classType][studentDivision].forEach(student => {
                    // console.log("student",student);

                    tableData.push([
                        student.currentClass || ' ', // Current Class
                        student.rollNo || ' ',
                        `${student.stdName || ''} ${student.stdFather || ''} ${student.stdSurname || ''}`.trim(),
                        classTotalAmount, // Remaining Fee (class-wise total amount)
                        '0.00', // Discount Amount
                        '0.00', // Remaining Amount
                        '0.00', // Before Pay
                        '-', // Payment Date
                        remainingFee,
                        student.fMobile || student.mobileNo || '',
                    ]);
                });
            });
        });
    } else if (selectedClass !== 'All') {
        // Only show students for the selected class and division
        const classWiseStudentsForClass = classWiseStudents[selectedClass] || {};
        
        // Check if the selected division is 'All' or specific division
        if (division === 'All') {
            Object.keys(classWiseStudentsForClass).forEach(studentDivision => {
                const classTotalAmount = classTypeToTotal[selectedClass] || '0.00';
                const remainingFee = classTotalAmount;
                classWiseStudentsForClass[studentDivision].forEach(student => {
                    // console.log("student",student);
                    
                    tableData.push([
                        student.currentClass || ' ', // Current Class
                        student.rollNo || ' ',
                       `${student.stdName || ''} ${student.stdFather || ''} ${student.stdSurname || ''}`.trim(),
    
                        classTotalAmount, // Remaining Fee (class-wise total amount)
                        '0.00', // Discount Amount
                        '0.00', // Remaining Amount
                        '0.00', // Before Pay
                        '-', // Payment Date
                        remainingFee,
                        student.fMobile || student.mobileNo || '',
                    ]);
                });
            });
        } else {
            // Only show students for the selected class and selected division
            const studentsForSelectedDivision = classWiseStudentsForClass[division] || [];
            const classTotalAmount = classTypeToTotal[selectedClass] || '0.00';
            const remainingFee = classTotalAmount;
            studentsForSelectedDivision.forEach(student => {
                    // console.log("student",student);

                tableData.push([
                    student.currentClass || ' ', // Current Class
                    student.rollNo || ' ',
                   `${student.stdName || ''} ${student.stdFather || ''} ${student.stdSurname || ''}`.trim(),
    
                    classTotalAmount, // Remaining Fee (class-wise total amount)
                    '0.00', // Discount Amount
                    '0.00', // Remaining Amount
                    '0.00', // Before Pay
                    '-', // Payment Date
                    remainingFee,
                    student.fMobile || student.mobileNo || '',
                ]);
            });
        }
    }
}
    
const handlePrint = () => {
    const receiptContainer = document.querySelector('.receipt-container');
    const printWindow = window.open('', '_blank', 'width=800,height=600');
    printWindow.document.write(`
      <html>
        <head>
         
          <style>
            /* Existing CSS rules */
            .receipt-container {
              width: 1200px;
              margin: 40px auto;
              padding: 20px;
              background-color: #f9f9f9;
              border: 1px solid #ddd;
              box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
            }
                 @page {
              size: A4 Portrait;
            margin: 3mm; /* this affects the margin in the printer settings */
          }
            .receipt-header {
              text-align: center;
              margin-bottom: 20px;
            }
            .taludis{
              text-align: left;
            }
            .print-hide {
        display: none; /* Hide the last column */
    }
            .receipt-header h1 {
              font-size: 24px;
              font-weight: bold;
              margin-bottom: 10px;
            }
            .receipt-header h2 {
              font-size: 20px;
              margin-bottom: 10px;
            }
            .receipt-header h3 {
              font-size: 14px;
              font-weight: bold;
              margin-bottom: 20px;
            }
            
            /* Add a border to the print section */
            body {
              border: 2px solid black;
              padding: 10px;
            }
            
            /* Add the table CSS rules */
            table {
              border-collapse: collapse;
              width: 100%;
            }
            
            th, td {
              border: 1px solid #0a0303;
              padding: 8px;
              text-align: left;
            }
            
            tr {
              margin-bottom: 10px;
            }
            
            th {
              background-color: #6495ED;
              font-weight: bold;
              color: white;
            }
            
            tr:hover {
              background-color: #f5f5f5;
            }
          </style>
        </head>
        <body>
          ${receiptContainer.innerHTML}
          <script>
            window.print();
          </script>
        </body>
      </html>
    `);
    printWindow.document.close();
  };
  const handleGoBack = () => {
    navigate(-1); 
  };

  const [selectedStudents, setSelectedStudents] = useState([]);
  const [checked, setChecked] = useState({});
  const handleCheckboxChange = (e, row) => {
    const { checked } = e.target;
    const studentName = row[2];
    // console.log("studentName",studentName);
    
    setChecked((prevChecked) => ({ ...prevChecked, [studentName]: checked }));

    if (checked) {
        // Add the student to the selected students list
        setSelectedStudents((prevStudents) => [...prevStudents, studentName]);
    } else {
        // Remove the student from the selected students list
        setSelectedStudents((prevStudents) =>
            prevStudents.filter((student) => student !== studentName)
        );
    }
};

const handleSelectAll = () => {
        const updatedChecked = {};
        const updatedSelectedStudents = [];
        const newSelectAllState = !selectAll;
        students.forEach(student => {
            const studentName = `${student.stdName || ''} ${student.stdFather || ''} ${student.stdSurname || ''}`.trim();
            updatedChecked[studentName] = newSelectAllState; // Set the checkbox state
            if (newSelectAllState && (student.fMobile || student.mobileNo)) { // Only add if mobile number is valid
                updatedSelectedStudents.push(studentName);
            }
        });
        setChecked(updatedChecked);
        setSelectedStudents(updatedSelectedStudents);
        setSelectAll(newSelectAllState);
    };



const sendFeeReminderOnWhatsApp = async () => {
    if (selectedStudents.length === 0) {
        setAlertMessage("No students selected");
        return;
    }

    const selectedRows = tableData.filter((row) => selectedStudents.includes(row[2]));
    if (selectedRows.length === 0) {
        setAlertMessage("No rows found with the selected students");
        return;
    }

    setSendingWhatsApp(true);
    try {
        // Fetch school's WhatsApp config from Firebase
        const configRes = await fetch(
            `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/whatsappConfig.json`
        );
        const whatsappConfig = await configRes.json();

        if (!whatsappConfig || !whatsappConfig.enabled) {
            setAlertMessage('WhatsApp fees webhook is not configured or disabled for this school.');
            setSendingWhatsApp(false);
            return;
        }

        const fallbackWebhook = "https://webhook.whatapi.in/webhook/6a9127b6c277c1989c47cd73?number=91xxxxxxxxxx&message=fee,StudentName,Class,Division,DueDate,TotalFee,PaidAmount,PendingAmount,PaymentMode,SchoolName,ContactNumber";
        const webhookTemplate = whatsappConfig.feesWebhook || fallbackWebhook;
        const staffNumbers = whatsappConfig.feesStaffAlertsEnabled
          ? [...new Set((whatsappConfig.feesStaffNumbers || '')
            .split(/[\s,;]+/)
            .map(number => number.replace(/\D/g, ''))
            .filter(Boolean)
            .map(number => number.startsWith('91') ? number : `91${number}`))]
          : [];
        console.log('[FeeWhatsApp] whatsappConfig:', JSON.stringify(whatsappConfig));
        console.log('[FeeWhatsApp] Using webhook template:', webhookTemplate);
        const schoolNameValue = schoolDetails?.schoolName || localStorage.getItem('schoolName') || 'School';
        
        let successCount = 0;
        let failureCount = 0;

        const sendPromises = selectedRows.map(async (row) => {
            const mobileNumber = row[9];
            let phone = mobileNumber ? String(mobileNumber).trim().replace(/\D/g, '') : '';
            
            if (!phone) {
                failureCount++;
                return;
            }
            if (!phone.startsWith('91')) phone = '91' + phone;

            const studentName = row[2] || '-';
            const className = row[0] || '-';
            
            // Find student to get actual division
            const studentObj = students.find(s => 
                `${s.stdName || ''} ${s.stdFather || ''} ${s.stdSurname || ''}`.trim() === studentName
            );
            const divName = studentObj?.division || (division !== 'All' ? division : '') || '-';
            
            const totalFee = row[3] || '0.00';
            const paidAmount = row[6] || '0.00';
            const pendingAmount = row[8] || '0.00';
            const contactNumber = schoolDetails?.mobileNumber || schoolDetails?.telephoneNumber || schoolDetails?.mobileNo || schoolDetails?.contactNo || localStorage.getItem('adminmob') || '-';
            const paymentMode = 'Online / Cash';
            const dueDate = 'As per school schedule';

            const [baseUrl, queryString] = webhookTemplate.split('?');
            const params = new URLSearchParams(queryString);
            
            // Set the number
            params.set('number', phone);

            // Replace placeholders in the message parameter
            const messageVal = params.get('message') || '';
            const parts = messageVal.split(',');
            
            const replacedParts = parts.map((part) => {
                const trimmed = part.trim().toLowerCase();
                if (trimmed === 'studentname') return studentName;
                if (trimmed === 'class') return className;
                if (trimmed === 'division') return divName;
                if (trimmed === 'duedate') return dueDate;
                if (trimmed === 'totalfee') return totalFee;
                if (trimmed === 'paidamount') return paidAmount;
                if (trimmed === 'pendingamount') return pendingAmount;
                if (trimmed === 'paymentmode') return paymentMode;
                if (trimmed === 'schoolname') return schoolNameValue;
                if (trimmed === 'contactnumber') return contactNumber;
                return part;
            });

            params.set('message', replacedParts.join(','));

            // Reconstruct URL with comma-separated values and space encoding %20
            const url = baseUrl + '?' + params.toString().replace(/%2C/g, ',').replace(/\+/g, '%20');

            console.log('Sending fee reminder:', url);

            try {
              const recipientUrls = [url, ...staffNumbers.map(number =>
                url.replace(/number=[^&]+/, `number=${number}`)
              )];
              await Promise.all(recipientUrls.map(recipientUrl =>
                fetch(recipientUrl, { method: 'GET', mode: 'no-cors' })
              ));
            } catch (err) {
                console.warn('WhatsApp failed for', studentName, err);
            }
            successCount++;
        });

        await Promise.all(sendPromises);
        setWhatsAppSent(true);
        setAlertMessage(`Messages sent successfully to ${successCount} students. Failed to send to ${failureCount} students.`);
    } catch (error) {
        console.error('Error fetching WhatsApp config:', error);
        setAlertMessage('Failed to fetch WhatsApp configuration.');
    } finally {
        setSendingWhatsApp(false);
    }
};


    return (
      <div className="main-content-of-page">
        <AlertMessage message={alertMessage} show={showAlert} />
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "20px",
          }}
        >
          <div style={{ display: "flex", justifyContent: "flex-start" }}>
            <button
              onClick={handleGoBack}
              style={{
                backgroundColor: "#FFFFFF",
                color: "black",
                padding: "7px 20px",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
                marginRight: "20px",
                border: "1px solid black",
                marginTop: "20px",
                marginLeft: "30px",
              }}
            >
              <i
                className="fa fa-arrow-left"
                style={{ fontSize: "22px", marginRight: "8px" }}
              ></i>
              Go Back
            </button>
            <button
              onClick={handlePrint}
              style={{
                backgroundColor: "#6495ED",
                color: "white",
                padding: "10px 20px",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
                marginLeft: "10px",
                marginTop: "20px",
              }}
            >
              Print Report
            </button>
          </div>
        <div className="toggle-container">
  
  {/* <div className="toggle-switch"> 
    <input
      type="checkbox"
      id="whatsappToggle"
      checked={whatsappOption === "api"}
      onChange={() =>
        setWhatsappOption(whatsappOption === "free" ? "api" : "free")
      }
    />
    <label htmlFor="whatsappToggle">
      <span className="toggle-label">{whatsappOption === "free" ? "Free WhatsApp" : "API WhatsApp"}</span>
    </label>
  </div> */}
</div>
<style jsx>
    {
        `
            .toggle-container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: 10px 0;
}

.toggle-switch {
  position: relative;
}

.toggle-switch input[type="checkbox"] {
  display: none;
}

.toggle-switch label {
  display: inline-block;
  width: 80px;
  height: 30px;
  background-color: #ccc;
  border-radius: 30px;
  position: relative;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.toggle-switch label::after {
  content: "";
  position: absolute;
  top: 3px;
  left: 4px;
  width: 24px;
  height: 24px;
  background-color: white;
  border-radius: 50%;
  transition: transform 0.3s ease;
}

.toggle-switch input[type="checkbox"]:checked + label {
  background-color: #4caf50;
}

.toggle-switch input[type="checkbox"]:checked + label::after {
  transform: translateX(48px);
}

.toggle-label {
  position: absolute;
  width: 100%;
  top: 35px;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
}

        `
    }
</style>

        </div>

        <div className="receipt-container">
          <div
            className="receipt-header"
            style={{
              border: "1px solid black",
              marginbottom: "10px",
              backgroundColor: "#F7F7F7",
              padding: "10px",
            }}
          >
            <h8>{schoolDetails?.sansthaName || " "}</h8>
            <h1>{schoolDetails?.schoolName || " "}</h1>

            <div className="taludis" style={{ textAlign: "center" }}>
              <h8>
                {language === "English" ? "Taluka:  " : "तालुका"}{" "}
                {schoolDetails?.taluka},{" "}
                {language === "English" ? "District:  " : "जिल्हा"}{" "}
                {schoolDetails?.jilha}
              </h8>
            </div>

            <h8>
              {language === "English" ? "Year:  " : "वर्ष"} {year}
            </h8>

            <h2
              style={{
                display: "block",
                border: "1px solid black",
                backgroundColor: "black",
                color: "white",
                padding: "5px",
                width: "200px",
                textAlign: "center",
                margin: "0 auto",
                borderRadius: "10px",
              }}
            >
              {language === "English" ? "Fee Report  " : "फी अहवाल"}{" "}
            </h2>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginLeft: "1%",
              }}
            >
              {/*<p>Division: {division}</p> */}
              <p>
                {language === "English" ? "Fee Status:  " : "फी स्थिती"}{" "}
                {selectedFee !== "N/A" ? selectedFee : "-"}
              </p>
            </div>
          </div>
          {isDataLoaded ? (
            <div>
              <table>
                <thead>
                  <tr>
                    <th style={{ backgroundColor: "#6495ED" }}>
                      {language === "English" ? "Class  " : "वर्ग"}
                    </th>
                    <th style={{ backgroundColor: "#6495ED" }}>
                      {language === "English" ? "Roll No  " : "रोल नंबर"}
                    </th>
                    <th style={{ backgroundColor: "#6495ED" }}>
                      {language === "English" ? "Student  " : "विद्यार्थी"}
                    </th>
                    <th style={{ backgroundColor: "#6495ED" }}>
                      {language === "English" ? "Fee " : "फी"}
                    </th>
                    <th style={{ backgroundColor: "#6495ED" }}>
                      {language === "English" ? "Discount (RS)  " : "सवलत (RS)"}
                    </th>
                    <th style={{ backgroundColor: "#6495ED" }}>
                      {language === "English"
                        ? "After Dis Fee  "
                        : "सवलत नंतर फी "}
                    </th>
                    <th style={{ backgroundColor: "#6495ED" }}>
                      {language === "English" ? "Paid Fee  " : "दिलेली फी"}
                    </th>
                    <th style={{ backgroundColor: "#6495ED" }}>
                      {language === "English" ? "Payment Date  " : "भरल्याची तारीख"}
                    </th>
                    <th style={{ backgroundColor: "#6495ED" }}>
                      {language === "English" ? "Balance Fee  " : "शिल्लक फी "}
                    </th>
                    <th style={{ backgroundColor: "#6495ED" }}>
                      {language === "English" ? "Mobile no" : "मोबाईल क्र"}
                    </th>

                      <th
                        className="print-hide"
                        style={{ backgroundColor: "#6495ED" }}
                      >
                        {language === "English" ? "Fee Alert" : "फी अलर्ट"}{" "}
                        <input
                          type="checkbox"
                          checked={selectAll}
                          onChange={handleSelectAll}
                        />
                      </th>
                  </tr>
                </thead>
                <tbody>
                  {tableData.length > 0 ? (
                    tableData.map((row, index) => (
                      <tr key={index}>
                        {row.map((cell, cellIndex) => (
                          <td key={cellIndex}>{cell}</td>
                        ))}

                        <td className="print-hide">
                          <input
                            type="checkbox"
                            checked={checked[row[2]]}
                            onChange={(e) => handleCheckboxChange(e, row)}
                          />
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="11"
                        style={{ textAlign: "center", color: "red" }}
                      >
                        No {selectedFee !== "N/A" ? selectedFee : " "}Students
                        Found In {selectedClass}.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>

              <button
                onClick={sendFeeReminderOnWhatsApp}
                className="btn print-hide"
                style={{
                  backgroundColor: whatsAppSent ? '#25D366' : '#128C7E',
                  color: 'white',
                  fontWeight: '600',
                  border: 'none',
                  padding: "10px 20px",
                  borderRadius: "5px",
                  cursor: "pointer",
                  float: "right",
                  marginTop: "20px",
                  marginBottom: "20px"
                }}
                disabled={sendingWhatsApp}
              >
                {sendingWhatsApp ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" />
                    Sending...
                  </>
                ) : whatsAppSent ? (
                  '✅ WhatsApp Sent'
                ) : (
                  '📲 Send Fee Reminder on WhatsApp'
                )}
              </button>
              <div style={{ clear: "both" }}></div>
            </div>
          ) : (
            <p>Loading...</p>
          )}
        </div>
        <div>
          <ul>
            {Object.entries(feeData).map(([key, fee]) => (
              <li key={key}>
                <strong>{fee.feetype}</strong>:
                <span>
                  {" "}
                  {language === "English" ? "Amount  " : "रक्कम"}
                  {fee.amount || " "}
                </span>
                <span>
                  {" "}
                  {language === "English" ? " Class " : "वर्ग"}
                  {fee.classType}
                </span>
                <span>
                  {" "}
                  {language === "English" ? "School Bus  " : "स्कूल बस"}
                  {fee.schoolBus ? "Yes" : "No"}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    );
}

export default Pavatino1;
